theme.headerSection = (function () {
  function header() {
    /* Mobile Menu Function */
    const offcanvasHeader = function () {
      const offcanvasOpen = document.querySelector(
          ".header__actions_btn--menu"
        ),
        offcanvasClose = document.querySelector(".offcanvas__close_btn"),
        offcanvasHeader = document.querySelector(".offcanvas-header"),
        offcanvasMenu = document.querySelectorAll(".offcanvas__menu"),
        body = document.querySelector("body");
      if (!offcanvasOpen || !offcanvasClose || !offcanvasHeader) return;
      const closeMenu = function () {
        if (!offcanvasHeader.classList.contains("open")) return;
        offcanvasHeader.classList.remove("open");
        offcanvasOpen.setAttribute("aria-expanded", "false");
        body.style.overflowY = "";
        removeTrapFocus(offcanvasOpen);
      };

      offcanvasMenu.forEach((item) => {
        item.querySelectorAll('.offcanvas__sub_menu').forEach((ul, index) => {
          const trigger = ul.previousElementSibling;
          if (!trigger || !trigger.classList.contains('nsm-submenu-trigger')) return;
          ul.id = `NsmMobileSubmenu-${index}`;
          trigger.setAttribute('aria-controls', ul.id);
          trigger.setAttribute('aria-expanded', 'false');
        });
      });

      /* Open/Close Menu On Click Toggle Button */
      offcanvasOpen.addEventListener("click", function (e) {
        e.preventDefault();
        offcanvasHeader.classList.add("open");
        offcanvasOpen.setAttribute("aria-expanded", "true");
        body.style.overflowY = "hidden";
        requestAnimationFrame(function () {
          if (offcanvasHeader.classList.contains("open")) trapFocus(offcanvasHeader, offcanvasClose);
        });
      });
      offcanvasClose.addEventListener("click", function (e) {
        e.preventDefault();
        closeMenu();
      });
      offcanvasHeader.addEventListener("keydown", function (event) {
        if (event.key === "Escape") closeMenu();
      });
      
      
      /* Open/Close Sub Menu On Click Toggle Button */
      offcanvasMenu.forEach((offcanvasMenuitem) => {
        offcanvasMenuitem
        .querySelectorAll(".nsm-submenu-trigger")
        .forEach(function (toggle) {
          toggle.addEventListener("click", function (e) {
            e.preventDefault();
            const parent = this.parentElement;
            if (parent.classList.contains("active")) {
              this.classList.remove("active");
              this.setAttribute("aria-expanded", "false");
              parent.classList.remove("active");
              parent
              .querySelectorAll(".offcanvas__sub_menu")
              .forEach(function (subMenu) {
                subMenu.parentElement.classList.remove("active");
                subMenu.previousElementSibling.classList.remove("active");
                subMenu.previousElementSibling.setAttribute("aria-expanded", "false");
                slideUp(subMenu);
              });
            } else {
              this.classList.add("active");
              this.setAttribute("aria-expanded", "true");
              parent.classList.add("active");
              slideDown(this.nextElementSibling);
              getSiblings(parent).forEach(function (item) {
                item.classList.remove("active");
                item
                .querySelectorAll(".offcanvas__sub_menu")
                .forEach(function (subMenu) {
                  subMenu.parentElement.classList.remove("active");
                  subMenu.previousElementSibling.classList.remove("active");
                  subMenu.previousElementSibling.setAttribute("aria-expanded", "false");
                  slideUp(subMenu);
                });
              });
            }
          });
        });                   
      })
      

      document.addEventListener("click", function (event) {
        if (
          !event.target.closest(".header__actions_btn--menu") &&
          !event.target.classList.contains(
            ".header__actions_btn--menu".replace(/\./, "")
          )
        ) {
          if (
            !event.target.closest(".offcanvas-header") &&
            !event.target.classList.contains(
              ".offcanvas-header".replace(/\./, "")
            )
          ) {
            closeMenu();
          }
        }
      });

      /* Remove Mobile Menu Open Class & Hide Mobile Menu When Window Width in More Than 991 */
      window.addEventListener("resize", function () {
        if (window.innerWidth >= 992) {
          closeMenu();
        }
      });
    };
    /* Mobile Menu Active */
    offcanvasHeader();
  }

  return header;
})();
